import { lazy, Suspense } from 'react'
import { Navigate, Outlet, Route, Routes, useLocation } from 'react-router-dom'
import { AppShell } from './components/AppShell'
import { Skeleton } from './components/ui'
import { useAuth } from './context/AuthContext'
import AuthPage, { ConfirmEmailPage, RecoverPasswordPage, UpdatePasswordPage } from './pages/AuthPage'
import HomePage from './pages/HomePage'
import LegalPage from './pages/LegalPage'
import NotFoundPage from './pages/NotFoundPage'

const PredictionsPage = lazy(() => import('./pages/PredictionsPage'))
const RankingPage = lazy(() => import('./pages/RankingPage'))
const LeaguesPage = lazy(() => import('./pages/LeaguesPage'))
const ProfilePage = lazy(() => import('./pages/ProfilePage'))
const AdminPage = lazy(() => import('./pages/AdminPage'))
const AccountSettingsPage = lazy(() => import('./pages/AccountSettingsPage'))
const ProfileHistoryPage = lazy(() => import('./pages/ProfileHistoryPage'))

function LoadingPage() {
  return <div className="page"><Skeleton className="skeleton--hero" /><Skeleton className="skeleton--section" /></div>
}

function ShellRoute() {
  const { loading } = useAuth()
  if (loading) return <LoadingPage />
  return <AppShell />
}

function RequireAuth() {
  const { user, loading } = useAuth()
  const location = useLocation()
  if (loading) return <LoadingPage />
  if (!user) return <Navigate to="/" replace state={{ authPrompt: true, returnTo: location.pathname }} />
  return <Outlet />
}

function AdminRoute() {
  const { isAdmin } = useAuth()
  if (!isAdmin) return <Navigate to="/" replace />
  return <AdminPage />
}

export default function App() {
  return (
    <Suspense fallback={<LoadingPage />}>
      <Routes>
        <Route path="/entrar" element={<AuthPage />} />
        <Route path="/auth/recuperar" element={<RecoverPasswordPage />} />
        <Route path="/auth/redefinir-senha" element={<UpdatePasswordPage />} />
        <Route path="/auth/confirmar" element={<ConfirmEmailPage />} />
        <Route path="/auth/callback" element={<Navigate to="/" replace />} />
        <Route path="/termos" element={<LegalPage />} />
        <Route path="/privacidade" element={<LegalPage />} />
        <Route element={<ShellRoute />}>
          <Route index element={<HomePage />} />
          <Route element={<RequireAuth />}>
            <Route path="palpites" element={<PredictionsPage />} />
            <Route path="ranking" element={<RankingPage />} />
            <Route path="ligas" element={<LeaguesPage />} />
            <Route path="ligas/entrar/:code" element={<LeaguesPage />} />
            <Route path="perfil" element={<ProfilePage />} />
            <Route path="perfil/configuracoes" element={<AccountSettingsPage />} />
            <Route path="perfil/historico" element={<ProfileHistoryPage />} />
            <Route path="u/:username" element={<ProfilePage />} />
            <Route path="u/:username/historico" element={<ProfileHistoryPage />} />
            <Route path="admin" element={<AdminRoute />} />
          </Route>
        </Route>
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </Suspense>
  )
}
